/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import {
  MaterialFormikSelect as Select,
  MaterialFormikSelectAutocomplete as SelectAutocomplete,
} from "components/haven-design/form/select";
import { extendedStatesList } from "components/haven-design/state-picker";
import styles from "./index.module.css";
import { TextMaskPhone, TextMaskCurrency } from "./helper-components";
import { FormValues } from "./index";

const UpdateFormFields: React.FC<{ values: FormValues }> = ({ values }) =>
  <div className={styles.section}>
    <Grid container spacing={0}>
      <div className={styles.sectionHeading}>
      Update applicant info
      </div>

      <Grid size={{ xs: 12 }}>
        <Select
          margin="dense"
          title="Household size"
          name="applicant.householdCount"
          style={{ backgroundColor: "white" }}
          options={
          // 1-12 range:
            [{ label: "", value: "" }].concat(
              [...Array(12).keys()].map(i => ({
                label: `${i + 1}`,
                value: `${i + 1}`,
              })),
            )}
        >
        </Select>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Input
          label="Household gross annual income"
          type="text"
          name="applicant.householdNetIncome"
          InputProps={{
            inputComponent: TextMaskCurrency as any,
          }}
          placeholder="$43,000"
          value={values.applicant.householdNetIncome}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Input
          label="Primary phone number"
          type="text"
          name="applicant.primaryPhone"
          placeholder="Phone number"
          InputProps={{
            inputComponent: TextMaskPhone,
          }}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Input
          label="Email address"
          type="text"
          name="applicant.email"
          placeholder="Email"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Input
          label="Mailing address"
          type="text"
          name="applicant.address1"
          placeholder="Mailing address"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Input
          type="text"
          name="applicant.address2"
          placeholder="Apartment / Suite #"
          label="Apartment / Suite #"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Input
              type="text"
              name="applicant.city"
              placeholder="Mailing city"
              label="Mailing city"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <SelectAutocomplete
              margin="dense"
              name="applicant.state"
              placeholder="Mailing state"
              title="Mailing state"
              options={extendedStatesList}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Input
              type="text"
              name="applicant.zip"
              placeholder="Mailing ZIP"
              label="Mailing ZIP"
              margin="dense"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </div>;

export default UpdateFormFields;
